import { useSelector } from "react-redux";
import Layout from "../../components/global/layout";
import { IoHandRightOutline } from "react-icons/io5";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useNavigate } from "react-router-dom";
import ReactECharts from 'echarts-for-react';
import environment from "../../environment";
import SelectDropdown from "../../components/common/SelectDropdown";
import { BsPostcardHeart } from "react-icons/bs";
import { FaEnvelopeOpenText, FaUserAlt } from "react-icons/fa";
import { RiExchangeDollarLine } from "react-icons/ri";
import loader from "../../methods/loader";

const Dashboard = () => {
  const user = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  const [cardData, setCardData] = useState({
    totalCards: 0,
    totalRecipients: 0,
    totalSubAdmin: 0,
    totalSender: 0,
    totalTransaction: 0
  })
  const [graphData, setGraphData]: any = useState({ cardCountsByMonth: [], senderUserCounts: [], recipientUserCounts: [], transactionCountsByMonth: [] })
  const [filters, setFilters] = useState({ year: new Date().getFullYear() })

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  useEffect(() => {
    getCardData()
    getGraphData()
  }, [])

  const getCardData = () => {
    loader(true)
    ApiClient.get(`user/dashboard`).then(res => {
      if (res.success) {
        setCardData(res.data)
      }
      loader(false)
    })
  }

  const getGraphData = (f = {}) => {
    loader(true)
    const param = { ...filters, ...f }
    ApiClient.get(`user/getDashboardGraph`, param).then(res => {
      if (res.success) {
        setGraphData(res?.data)
      }
      loader(false)
    })
  }

  const getYearsFrom1925ToNow = () => {
    const startYear = 2024;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= startYear; year--) {
      years.push({ id: year, name: year });
    }
    return years;
  };

  const handleYearFilter = (value: any) => {
    setFilters((prev: any) => ({ ...prev, year: value }))
    getGraphData({ year: value })
  }

  const months = graphData?.cardCountsByMonth.map((item: any) => item?.month);
  const monthLabels = months.map((m: any) => monthNames[m - 1]);
  const cardsData = graphData?.cardCountsByMonth.map((item: any) => item?.count);
  const senderData = graphData?.senderUserCounts.map((item: any) => item?.count);
  const recipientData = graphData?.recipientUserCounts.map((item: any) => item?.count);
  const transactionData = graphData?.transactionCountsByMonth.map((item: any) => item?.count);

  const chartOption = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      // data: ["Cards", "Senders", "Recipients", "Transactions"],
      data: ["Cards", "Senders", "Transactions"],
      bottom: 0
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: monthLabels,
      axisLabel: {
        rotate: 30
      }
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        name: "Cards",
        type: "bar",
        data: cardsData,
        itemStyle: {
          color: "#F58D18"
        },
        label: {
          show: true,
          position: "inside",
          color: "#fff",
          fontWeight: "bold"
        }
      },
      {
        name: "Senders",
        type: "bar",
        data: senderData,
        itemStyle: {
          color: "#FF8F6B"
        },
        label: {
          show: true,
          position: "inside",
          color: "#fff",
          fontWeight: "bold"
        }
      },
      // {
      //   name: "Recipients",
      //   type: "bar",
      //   data: recipientData,
      //   itemStyle: {
      //     color: "#5B93FF"
      //   },
      //   label: {
      //     show: true,
      //     position: "inside",
      //     color: "#fff",
      //     fontWeight: "bold"
      //   }
      // },
      {
        name: "Transactions",
        type: "bar",
        data: transactionData,
        itemStyle: {
          color: "#f8d144"
        },
        label: {
          show: true,
          position: "inside",
          color: "#fff",
          fontWeight: "bold"
        }
      }
    ],
    barCategoryGap: '50%',
    barGap: '0%'
  };

  return (
    <>
      <Layout>
        <h4 className="text-2xl font-bold mb-3 flex items-center gap-2 capitalize">
          <IoHandRightOutline className="text-3xl slow-shake text-[#130264]" />
          <span className="">Hi,</span> {user?.fullName}
        </h4>
        <div className="shadow-box w-full bg-white rounded-lg mt-6 p-6">
          <div className=" grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <div onClick={e => navigate(`/card`)} className="cursor-pointer hover:shadow-md flex flex-col-reverse border border-gray-200 shadow-sm px-6 py-2 rounded-lg relative">
              <dt className="text-base leading-7 text-black/40">Total Cards</dt>
              <dd className="text-2xl font-bold leading-9 text-black">{cardData?.totalCards}</dd>
              <FaEnvelopeOpenText size={25} className="absolute right-6 top-1/2 -translate-y-1/2 text-[#ffd5b9]" />
            </div>
            <div onClick={e => navigate(`/users`)} className="cursor-pointer hover:shadow-md flex flex-col-reverse border border-gray-200 shadow-sm px-6 py-2 rounded-lg relative">
              <dt className="text-base leading-7 text-black/40">Total Senders</dt>
              <dd className="text-2xl font-bold leading-9 text-black">{cardData?.totalSender}</dd>
              <FaUserAlt size={25} className="absolute right-6 top-1/2 -translate-y-1/2 text-[#ffd5b9]" />
            </div>
            {/* <div onClick={e => navigate(`/users?role=${environment.recipientRole}`)} className="cursor-pointer hover:shadow-md flex flex-col-reverse border border-gray-200 shadow-sm px-6 py-2 rounded-lg relative">
              <dt className="text-base leading-7 text-black/40">Total Recipients</dt>
              <dd className="text-2xl font-bold leading-9 text-black">{cardData?.totalRecipients}</dd>
              <FaUserAlt size={25} className="absolute right-6 top-1/2 -translate-y-1/2 text-[#ffd5b9]" />
            </div> */}
            <div onClick={e => navigate(`/transaction`)} className="cursor-pointer hover:shadow-md flex flex-col-reverse border border-gray-200 shadow-sm px-6 py-2 rounded-lg relative">
              <dt className="text-base leading-7 text-black/40">Total Transactions</dt>
              <dd className="text-2xl font-bold leading-9 text-black">{cardData?.totalTransaction}</dd>
              <RiExchangeDollarLine size={30} className="absolute right-6 top-1/2 -translate-y-1/2 text-[#ffd5b9]" />
            </div>
          </div>
        </div>
        <div className="shadow-box w-full bg-white rounded-lg mt-6 p-6">
          <div className="flex justify-end">
            <SelectDropdown
              id="statusDropdown"
              displayValue="name"
              placeholder="Select Year"
              theme="search"
              isClearable={false}
              intialValue={filters?.year}
              result={(e: any) => handleYearFilter(e?.value)}
              options={getYearsFrom1925ToNow()}
            />
          </div>
          <ReactECharts option={chartOption} style={{ height: '400px', width: '100%' }} />
        </div>
      </Layout>
    </>
  );
};

export default Dashboard;
